import { render, staticRenderFns } from "./HowItWorksSend.vue?vue&type=template&id=7439becb"
import script from "./HowItWorksSend.vue?vue&type=script&lang=js"
export * from "./HowItWorksSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports